import { ReactNode, useState } from "react";

import Header from "../components/Header";
import Seo from "../components/shared/Seo";

type PrivacyLayoutProps = {
  app: "shoplist" | "stackclash";
  children: ReactNode;
};

/**
 * Preserves the original privacy-page chrome exactly as App Store /
 * Play Store listings expect it: app header, store badge, and the
 * `?isApp=true` param that hides the badge inside webviews.
 */
const PrivacyLayout = ({ app, children }: PrivacyLayoutProps) => {
  const [isApp] = useState(
    () => new URLSearchParams(window.location.search).get("isApp") === "true"
  );

  const isStackClash = app === "stackclash";
  const headerIcon = isStackClash
    ? require("../assets/transparent_icon.png")
    : require("../assets/icon.png");
  const headerName = isStackClash ? "StackClash" : "ShopList";
  const storeUrl = isStackClash
    ? "https://apps.apple.com/us/app/stack-clash-build-high/id6754847803"
    : "https://apps.apple.com/us/app/shoplist-lists-made-easy/id6744070581";

  return (
    <div className="App">
      <Seo
        title={`${headerName} — Privacy Policy`}
        description={`Privacy policy for the ${headerName} mobile app by Konstantinos Efkarpidis.`}
        path={isStackClash ? "/stackClash/privacy" : "/privacy"}
      />
      <Header
        label={headerName}
        hideDownloadBadge={isApp}
        img={headerIcon}
        storeUrl={storeUrl}
        app={app}
      />
      {children}
    </div>
  );
};

export default PrivacyLayout;
